import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { GetEpcsQueue } from "../../Apis/AuthApiServices";
import { loadingEpcsQueue, setEpcsQueue } from "../Slice/EPCSQueueSlice";

function* onLoadOnLoadEPCSQueueAsync({ payload }: any) {
  const params = new URLSearchParams();
  let doctorId: any = localStorage.getItem("doctorId");
  params.append("doctorId", doctorId);
  params.append("pageNumber", payload.pageNumber);
  params.append("pageSize", payload.pageSize);
  try {
    const result: AxiosResponse = yield GetEpcsQueue(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setEpcsQueue({
          EPCSQueueData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setEpcsQueue({
          EPCSQueueData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error) {
    yield put(
      setEpcsQueue({
        EPCSQueueData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadEPCSQueue() {
  yield takeLatest(loadingEpcsQueue.type, onLoadOnLoadEPCSQueueAsync);
}

const EPCSQueueSaga = [fork(onLoadEPCSQueue)];
export default EPCSQueueSaga;
